const STORAGE_KEY = "fschool-holland-test-results";

export function loadHollandResults() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveHollandResults(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function clearHollandResults() {
  localStorage.removeItem(STORAGE_KEY);
}
